/**
 * Firestore `generatedNote.type === "evaluationform"` does not encode who completed it.
 * Infer from `physiotherapist_id` / `doctor_id` vs tenant hr.employee lists (same IDs as doctor app).
 */

function extractDoctorRecordId(note) {
  const candidates = [note.physiotherapist_id, note.doctor_id, note.doctorId];
  for (const c of candidates) {
    if (c == null) continue;
    if (Array.isArray(c) && c[0] != null) return String(c[0]).trim();
    if (typeof c === "number" && Number.isFinite(c)) return String(c);
    if (typeof c === "string" && c.trim() !== "") return c.trim();
  }
  return null;
}

/**
 * @returns {"psychiatrist"|"psychologist"|null}
 */
export function inferEvaluationFormCompletedBy(note, psychiatrists, psychologists) {
  const idStr = extractDoctorRecordId(note);
  if (!idStr) return null;
  const pr = new Set((psychiatrists || []).map((d) => String(d.id)));
  const py = new Set((psychologists || []).map((d) => String(d.id)));
  const inPr = pr.has(idStr);
  const inPy = py.has(idStr);
  if (inPy && !inPr) return "psychologist";
  if (inPr && !inPy) return "psychiatrist";
  if (inPr && inPy) return "psychiatrist";
  return null;
}

/**
 * Table / modal copy: evaluation form + who completed it.
 */
export function formatEvaluationFormTypeDisplay(note, psychiatrists, psychologists) {
  const role = inferEvaluationFormCompletedBy(note, psychiatrists, psychologists);
  if (role === "psychologist") return "Evaluation form (Psychologist)";
  if (role === "psychiatrist") return "Evaluation form (Psychiatrist)";
  return "Evaluation form (completer unknown — see Doctor column)";
}
